import { UserEntity } from '../entities/user.entity';

export abstract class CurrentUserStatePort {
  abstract isInitialized(): boolean;
  abstract getCurrentUser(): UserEntity | null;
  abstract setCurrentUser(user: UserEntity | null): void;
}
